import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteListEmployer = {
  deleteListEmployer: { data: null, loading: false, error: null },
};

export const deleteListEmployer = createAsyncThunk('user/deleteListEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/employers/active`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteListEmployer = {
  [deleteListEmployer.pending]: (state) => {
    state.deleteListEmployer.loading = true;
    state.deleteListEmployer.error = null;
  },
  [deleteListEmployer.fulfilled]: (state, action) => {
    state.deleteListEmployer.loading = false;
    state.deleteListEmployer.data = true;
    state.deleteListEmployer.error = null;
  },
  [deleteListEmployer.rejected]: (state, action) => {
    state.deleteListEmployer.loading = false;
    state.deleteListEmployer.error = action.payload;
  },
};
